export interface UploadedFile {
  id: string;
  original_name: string;
  file_type: string;
  file_extension: string;
  url: string;
  created_at: string;
}

export interface UploadFileRequest {
  original_name: string;
}

export interface UploadFileResponse {
  id: string;
  url: string;
  original_name: string;
  file_type: string;
  file_extension: string;
  created_at: string;
}

// Backend API types to match Python backend exactly
export interface CreatePreSignedUrlRequest {
  original_name: string;
}

export interface CreatePreSignedUrlResponse {
  upload_url: string;
  file_path: string;
  id: string;
}

// File type and extension enums to match backend
export enum FileType {
  CUSTOM = "custom"
}

export enum FileExtension {
  JPG = "jpg",
  PNG = "png",
  PDF = "pdf",
  DOC = "doc",
  DOCX = "docx",
  ZIP = "zip",
  MP3 = "mp3",
  AAC = "aac",
  M4A = "m4a",
  MP4 = "mp4",
  WEBM = "webm",
  WAV = "wav",
  PPT = "ppt",
  PPTX = "pptx",
  SVG = "svg",
  JPEG = "jpeg",
  CSV = "csv",
  XLS = "xls",
  XLSX = "xlsx"
}

// Helper function to get file extension from filename
export const getFileExtension = (filename: string): FileExtension | null => {
  const extension = filename.split('.').pop()?.toLowerCase();
  if (extension && Object.values(FileExtension).includes(extension as FileExtension)) {
    return extension as FileExtension;
  }
  return null;
}; 